var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatherSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.722,
    height: 13.722,
    viewBox: "0 0 13.722 13.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-search",
    "data-name": "Icon feather-search",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13882",
    "data-name": "Path 13882",
    d: "M15.088,9.794A5.294,5.294,0,1,1,9.794,4.5a5.294,5.294,0,0,1,5.294,5.294Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13883",
    "data-name": "Path 13883",
    d: "M27.854,27.854l-2.879-2.879",
    transform: "translate(-15.942 -15.942)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherSearch);
export default __webpack_public_path__ + "static/media/feather-search.82dc1fe77a3f5c8d98f7f22aa2bd5b11.svg";
export { ForwardRef as ReactComponent };